package com.snakesworld.game.navigation

import androidx.navigation3.runtime.NavKey
import androidx.savedstate.serialization.SavedStateConfiguration
import kotlinx.serialization.Serializable
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic
import kotlinx.serialization.modules.subclass

@Serializable
data object SplashRoute : NavKey

@Serializable
data object HubRoute : NavKey

@Serializable
data object MainMenuRoute : NavKey

@Serializable
data object SinglePlayerMenuRoute : NavKey

@Serializable
data class ConnectingRoute(
    val userId: String = "",
    val nickname: String,
    val skinId: String,
) : NavKey

@Serializable
data class InGameRoute(
    val assignedId: String,
    val nickname: String,
    val skinId: String,
    val isSinglePlayer: Boolean = false,
) : NavKey

@Serializable
data object LeaderboardRoute : NavKey

@Serializable
data object SettingsRoute : NavKey

val AppSavedStateConfiguration = SavedStateConfiguration {
    serializersModule = SerializersModule {
        polymorphic(NavKey::class) {
            subclass(SplashRoute::class)
            subclass(HubRoute::class)
            subclass(MainMenuRoute::class)
            subclass(SinglePlayerMenuRoute::class)
            subclass(ConnectingRoute::class)
            subclass(InGameRoute::class)
            subclass(LeaderboardRoute::class)
            subclass(SettingsRoute::class)
        }
    }
}
